import React from 'react'
import { Link } from 'react-router-dom'
import { useParamountAuth } from 'context/ParamountAuthContext'
import './BananaStuffHome.scss'

// Hidden SuperUser-only index — no nav link, only reachable via direct URL
// (/bananastuff). Links out to each individual internal tool.
const TOOLS = [
  {
    to: '/bananastuff/deleteUser',
    title: 'Delete User',
    description: 'Look up a user by email and permanently delete their account. This action is irreversible.',
  },
  {
    to: '/bananastuff/regenerateChecklist',
    title: 'Regenerate Checklist PDF',
    description: 'Recovery tool for site inspection checklists whose PDF failed to generate at submission time.',
  },
  {
    to: '/bananastuff/activityLogs',
    title: 'Activity Logs',
    description: 'Audit supervisor/tradie activity — check-ins/outs, SWMS signatures, hazard reports and checklist submissions.',
  },
]

export default function BananaStuffHome() {
  const { userRoles } = useParamountAuth()
  const isSuperUser = (userRoles || []).includes('SuperUser')

  if (!isSuperUser) {
    return <div className="bananastuff-home">Unauthorized</div>
  }

  return (
    <div className="bananastuff-home">
      <div className="bananastuff-home-title">🍌 Banana Stuff</div>
      <div className="bananastuff-home-grid">
        {TOOLS.map((tool) => (
          <Link key={tool.to} to={tool.to} className="bananastuff-home-card">
            <div className="bananastuff-home-card-title">{tool.title}</div>
            <div className="bananastuff-home-card-description">{tool.description}</div>
          </Link>
        ))}
      </div>
    </div>
  )
}
